<script setup>
import { computed } from 'vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const props = defineProps({
  modelValue: {
    type: Set,
    default: () => new Set(),
  },
  allItems: {
    type: Array,
    default: () => [],
  },
  selectAllLabel: {
    type: String,
    default: 'Select all',
  },
  selectedCountLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const allSelected = computed(() => {
  if (!props.allItems.length) return false;
  return props.allItems.every(item => props.modelValue.has(item.id));
});

const someSelected = computed(() => {
  if (!props.allItems.length) return false;
  return (
    props.allItems.some(item => props.modelValue.has(item.id)) &&
    !allSelected.value
  );
});

const toggleAll = () => {
  const newSet = new Set(props.modelValue);
  if (allSelected.value) {
    props.allItems.forEach(item => newSet.delete(item.id));
  } else {
    props.allItems.forEach(item => newSet.add(item.id));
  }
  emit('update:modelValue', newSet);
};
</script>

<template>
  <div
    class="flex items-center gap-3 p-2 bg-n-solid-2 rounded-xl border border-n-container"
  >
    <Checkbox
      :model-value="allSelected"
      :indeterminate="someSelected"
      @update:model-value="toggleAll"
    />
    <span v-if="selectedCountLabel" class="text-sm font-medium text-n-slate-12">
      {{ selectedCountLabel }}
    </span>
    <span v-else class="text-sm text-n-slate-11">
      {{ selectAllLabel }}
    </span>
    <slot name="secondary-actions" />
    <slot name="actions" />
  </div>
</template>
